import { render, staticRenderFns } from "./Actionarea.vue?vue&type=template&id=b9e9919c&scoped=true"
import script from "./Actionarea.vue?vue&type=script&lang=js"
export * from "./Actionarea.vue?vue&type=script&lang=js"
import style0 from "./Actionarea.vue?vue&type=style&index=0&id=b9e9919c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e9919c",
  null
  
)

export default component.exports